var CircularBuffer = (function () {
    function CircularBuffer(size, data) {
        if (data === void 0) { data = []; }
        if (data && data.length > size) {
            throw new Error('CircularBuffer error: Starting data set is bigger than declared size of CircularBuffer');
        }
        this._size = size;
        this.data = data;
        this.pointer = 0;
    }
    CircularBuffer.prototype.clear = function () {
        this.data = [];
        return this;
    };
    CircularBuffer.prototype.push = function (obj) {
        if (this.data.length < this._size) {
            this.data.push(obj);
            return this;
        }
        this.data[this.pointer] = obj;
        this.pointer = (this.pointer + 1) % this._size;
        return this;
    };
    CircularBuffer.prototype.get = function (index) {
        return this.data[index];
    };
    CircularBuffer.prototype.getAll = function () {
        return this.data;
    };
    CircularBuffer.prototype.show = function () {
        console.log(this.data);
    };
    Object.defineProperty(CircularBuffer.prototype, "size", {
        get: function () { return this._size; },
        enumerable: false,
        configurable: true
    });
    return CircularBuffer;
}());
export { CircularBuffer };
